import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const EmployerSection = ({ number, formData, handleChange, prefix }) => (
  <div className="bg-gray-50 p-6 rounded-lg space-y-4">
    <h4 className="font-bold text-lg">Employer {number} {number > 1 && '(if applicable)'}</h4>
    
    <div>
      <Label htmlFor={`${prefix}_name`}>Employer Name</Label>
      <Input
        id={`${prefix}_name`}
        value={formData[`${prefix}_name`]}
        onChange={(e) => handleChange(`${prefix}_name`, e.target.value)}
      />
    </div>

    <div>
      <Label htmlFor={`${prefix}_address`}>Street Address</Label>
      <Input
        id={`${prefix}_address`}
        value={formData[`${prefix}_address`]}
        onChange={(e) => handleChange(`${prefix}_address`, e.target.value)}
      />
    </div>

    <div className="grid md:grid-cols-3 gap-4">
      <div>
        <Label htmlFor={`${prefix}_city`}>City</Label>
        <Input
          id={`${prefix}_city`}
          value={formData[`${prefix}_city`]}
          onChange={(e) => handleChange(`${prefix}_city`, e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_state`}>State</Label>
        <Input
          id={`${prefix}_state`}
          value={formData[`${prefix}_state`]}
          onChange={(e) => handleChange(`${prefix}_state`, e.target.value)}
          placeholder="PA"
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_zip`}>ZIP Code</Label>
        <Input
          id={`${prefix}_zip`}
          value={formData[`${prefix}_zip`]}
          onChange={(e) => handleChange(`${prefix}_zip`, e.target.value)}
        />
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor={`${prefix}_title`}>Job Title</Label>
        <Input
          id={`${prefix}_title`}
          value={formData[`${prefix}_title`]}
          onChange={(e) => handleChange(`${prefix}_title`, e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_dates`}>Dates of Employment (From – To)</Label>
        <Input
          id={`${prefix}_dates`}
          value={formData[`${prefix}_dates`]}
          onChange={(e) => handleChange(`${prefix}_dates`, e.target.value)}
          placeholder="MM/YYYY - MM/YYYY"
        />
      </div>
    </div>

    <div>
      <Label htmlFor={`${prefix}_pay_rate`}>Pay Rate</Label>
      <Input
        id={`${prefix}_pay_rate`}
        value={formData[`${prefix}_pay_rate`]}
        onChange={(e) => handleChange(`${prefix}_pay_rate`, e.target.value)}
        placeholder="$15/hour"
      />
    </div>

    <div className="grid md:grid-cols-2 gap-4">
      <div>
        <Label htmlFor={`${prefix}_supervisor`}>Supervisor's Name</Label>
        <Input
          id={`${prefix}_supervisor`}
          value={formData[`${prefix}_supervisor`]}
          onChange={(e) => handleChange(`${prefix}_supervisor`, e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${prefix}_supervisor_phone`}>Supervisor's Phone Number</Label>
        <Input
          id={`${prefix}_supervisor_phone`}
          type="tel"
          value={formData[`${prefix}_supervisor_phone`]}
          onChange={(e) => handleChange(`${prefix}_supervisor_phone`, e.target.value)}
        />
      </div>
    </div>

    <div>
      <Label htmlFor={`${prefix}_reason_leaving`}>Reason for Leaving</Label>
      <Textarea
        id={`${prefix}_reason_leaving`}
        value={formData[`${prefix}_reason_leaving`]}
        onChange={(e) => handleChange(`${prefix}_reason_leaving`, e.target.value)}
        rows={2}
      />
    </div>

    <div>
      <Label>May we contact this employer?</Label>
      <div className="flex gap-4 mt-2">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name={`${prefix}_may_contact`}
            value="yes"
            checked={formData[`${prefix}_may_contact`] === 'yes'}
            onChange={(e) => handleChange(`${prefix}_may_contact`, e.target.value)}
          />
          Yes
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name={`${prefix}_may_contact`}
            value="no"
            checked={formData[`${prefix}_may_contact`] === 'no'}
            onChange={(e) => handleChange(`${prefix}_may_contact`, e.target.value)}
          />
          No
        </label>
      </div>
    </div>
  </div>
);

const Step5Employment = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Employment History</h3>
        <p className="text-gray-600">Please provide your employment history (optional)</p>
      </div>

      <EmployerSection number={1} formData={formData} handleChange={handleChange} prefix="emp1" />
      <EmployerSection number={2} formData={formData} handleChange={handleChange} prefix="emp2" />
      <EmployerSection number={3} formData={formData} handleChange={handleChange} prefix="emp3" />
    </div>
  );
};

export default Step5Employment;